import { InMemoryCache } from '@apollo/client';

export const cache = new InMemoryCache({
  addTypename: false, // Avoids __filename to be added to objects
  typePolicies: {},
});

export default cache;
